// @ts-nocheck
import React, { memo, useState } from "react";
import styles from "./CompletedTable.module.scss";
import Table, { Column } from "app/components/Table/Table";
import { RouteComponentProps, withRouter } from "react-router-dom";
// import { Button } from "antd";
import { getTestDate } from "app/helpers/deviceHelper";
import { useTranslation } from "react-i18next";
import { useFetchPaginatedData } from "app/hooks/hooks";
import {
  DeviceHealthApiV2DeviceHealthCompletedGetRequest,
  ListWrapperDeviceHealthListItemDTO,
  ReaderType,
} from "@generated/v2";
import { PaginationConfig } from "antd/lib/table";
import qs from "query-string";
import { getOrderBy } from "app/helpers/apiHelper";
import ErrorFallbackUI from "app/components/ErrorFallbackUI";
import { deviceHealthCompletedGet } from "app/api/v2/deviceHealthApi";
import { TabParams } from "app/types/routerType";
import { formatRoute } from "react-router-named-routes";
import { TabOptions } from "app/constants/deviceHealthConst";
import { DeviceConst } from "app/constants/deviceConst";
import { PRIVATE_ROUTES } from "app/routers/Router.config";
import MetricIcon from "../MetricIcon/MetricIcon";
import DeviceDetailsModal from "../DeviceDetailsModal/DeviceDetailsModal";

interface IProps extends RouteComponentProps<TabParams> {
  customerId?: number;
  siteId?: number;
  readerType?: ReaderType;
}

const CompletedTable = (props: IProps) => {
  const { customerId, siteId, history, location, match, readerType } = props;
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TabOptions>();
  const [currentItemId, setCurrentItemId] = useState<number | undefined>(
    undefined
  );

  /** Get completed devices data */
  const { data, loading, pagination, orderBy } = useFetchPaginatedData<
    ListWrapperDeviceHealthListItemDTO,
    DeviceHealthApiV2DeviceHealthCompletedGetRequest
  >(deviceHealthCompletedGet, {
    shouldCallApi: !!customerId,
    withOrderBy: true,
    params: {
      readerType: readerType ? [readerType] : undefined,
      customerId: customerId ?? undefined,
      siteId: siteId ?? undefined,
    },
  });

  const showModal = (path: string, id?: number) => {
    const parameters = {
      tab: DeviceConst.Details,
      itemId: id && id,
      itemName: DeviceConst.Completed,
    };
    setCurrentItemId(id);
    const newRoute = formatRoute(path, parameters);
    history.push({ pathname: newRoute, search: location.search });
  };

  const closeModal = () => {
    const newRoute = formatRoute(PRIVATE_ROUTES.DEVICE_HEALTH_SCREEN.path);

    history.push({
      pathname: newRoute,
      search: location.search,
    });
  };

  /** pagination, order */
  const handleTableChange = (pagination: PaginationConfig, filters, sorter) => {
    // Keep the old search params
    const currentSearch = qs.parse(location.search);

    // and overwrite or add new values
    const values = {
      ...currentSearch,
      page: pagination.current,
      orderBy:
        (sorter.order && getOrderBy(sorter.columnKey, sorter.order)) ||
        undefined,
    };

    history.push({
      pathname: location.pathname,
      search: qs.stringify(values, { arrayFormat: "comma" }),
    });
  };

  return (
    <ErrorFallbackUI>
      <div className={styles.tableSection}>
        <h1 className={styles.pageTitle}>
          {t("deviceHealth.completedTableTitle")}
        </h1>
        <Table
          dataSource={loading ? [] : data}
          loading={loading}
          pagination={pagination}
          rowKey="readerSerialNumber"
          onChange={handleTableChange}
          onRow={record => {
            return {
              onClick: () =>
                record &&
                !isNaN(Number(record.id)) &&
                showModal(PRIVATE_ROUTES.DETAILS_VIEW_SCREEN.path, record.id),
            };
          }}
          rowClassName={() => "ant-table-row-custom-cursor"}
        >
          <Column
            title={t("deviceHealth.columnDate")}
            dataIndex="testDate"
            width={180}
            align="center"
            render={testDate =>
              getTestDate(testDate) ?? t("default.notApplicable")
            }
            sorter
            sortOrder={
              (orderBy?.key === "testDate" && orderBy.direction) || undefined
            }
          />
          <Column
            title={t("deviceHealth.columnSite")}
            dataIndex="siteName"
            align="center"
          />
          <Column
            title={t("deviceHealth.columnSerialNumber")}
            dataIndex="readerSerialNumber"
            align="center"
            width={170}
          />
          <Column
            title={t("deviceHealth.columnNoOfTests")}
            dataIndex="testSinceLastVerification"
            align="center"
            width={183}
            sorter
            sortOrder={
              (orderBy?.key === "testSinceLastVerification" &&
                orderBy.direction) ||
              undefined
            }
          />
          <Column
            title={t("deviceHealth.columnTemperature")}
            dataIndex="temperatureFailed"
            align="center"
            render={element => (
              <MetricIcon metric={element === null ? null : !element} />
            )}
          />
          <Column
            align="center"
            title={t("deviceHealth.columnCalibrated")}
            dataIndex="calibrationFailed"
            render={element => (
              <MetricIcon metric={element === null ? null : !element} />
            )}
          />
          <Column
            align="center"
            title={t("deviceHealth.columnLightIntensity")}
            dataIndex="lightIntensityFailed"
            render={element => (
              <MetricIcon metric={element === null ? null : !element} />
            )}
          />
          {/* <Column
            key="actions"
            fixed="right"
            align="center"
            render={(text: any, record: any) => (
              <Button
                id={record.id}
                type="link"
                icon="more"
                className={styles.action}
              />
            )}
          /> */}
        </Table>
      </div>
      <DeviceDetailsModal
        visible={
          match.path === PRIVATE_ROUTES.DETAILS_VIEW_SCREEN.path &&
          match.params?.itemName === DeviceConst.Completed
        }
        key={`DeviceHealth-${DeviceConst.Completed}-${match.params?.itemId}`}
        onClose={closeModal}
        setActiveTab={setActiveTab}
        itemId={currentItemId}
        activeTab={activeTab}
        itemName={DeviceConst.Completed}
      />
    </ErrorFallbackUI>
  );
};

export default withRouter(memo(CompletedTable));
